module.exports = __webpack_public_path__ + "media/images/postal-2ed708116e48b503b804e3a1dc0f47e1.png";